export default "__VITE_ASSET__C7I7HVje__"